import { Input, type InputRef } from "antd";
import { useId, type Ref } from "react";
import "./StoreTextField.css";

export default function StoreTextField({ label, value, onChange, disabled, required, maxLength, autoFocus, hideLabel = false, inputRef }: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  maxLength?: number;
  autoFocus?: boolean;
  hideLabel?: boolean;
  inputRef?: Ref<InputRef>;
}) {
  const id = useId();
  return (
    <div className="store-text-field">
      <label
        htmlFor={id}
        className={hideLabel ? "store-text-field__hidden-label" : undefined}
      >
        {label}
      </label>
      <Input
        ref={inputRef}
        id={id}
        value={value}
        onChange={function (event) { onChange(event.target.value); }}
        disabled={disabled}
        required={required}
        maxLength={maxLength}
        autoFocus={autoFocus}
      />
    </div>
  );
}
